import { InjectionToken } from '@angular/core';
import { ReputationConfig } from './interfaces/reputation-config.interface';

export const REPUTATION_CONFIG_TOKEN = new InjectionToken<ReputationConfig>(
  '[Reputation]: Token for reputation library configuration'
);
